import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider } from './AuthContext'
import { I18nProvider, readLang } from './i18n'
import { ErrorBoundary } from './components/ErrorBoundary'
import App from './App'
import './index.css'
import './theme-dark.css'
import { applyTheme } from './shell/theme'

// Thème posé avant le premier rendu : pas de flash clair en mode sombre.
applyTheme()

// Langue posée de même : l'attribut lang du document sert aux lecteurs d'écran
// et à la césure dès la première peinture, avant que React ne soit monté.
document.documentElement.lang = readLang()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* La langue est au-dessus de l'authentification : le sélecteur sert
        aussi sur l'écran de connexion. */}
    <I18nProvider>
      <ErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    </I18nProvider>
  </StrictMode>,
)
